// extracted by mini-css-extract-plugin
module.exports = {"banner":"WelcomeBanner_banner__3W6ES","avatar":"WelcomeBanner_avatar__VepS0"};